import { render, staticRenderFns } from "./BoxWrapType.vue?vue&type=template&id=c4497af4&"
import script from "./BoxWrapType.vue?vue&type=script&lang=js&"
export * from "./BoxWrapType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports